import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import QualificationsPage from './QualificationsPage'
import GeneralSettings from './components/GeneralSettings'
import ListSettings from './components/ListSettings'
import { Settings, CheckSquare, List, Activity, UserCog } from 'lucide-react'
import './SettingsPage.css'

export default function SettingsPage() {
    const { t } = useTranslation()
    const [activeTab, setActiveTab] = useState('general')

    return (
        <div className="settings-page">
            <div className="settings-header">
                <h1 className="settings-title">Paramétrage</h1>
            </div>

            <div className="settings-layout">
                {/* Sidebar Navigation */}
                <div className="settings-sidebar">
                    <nav className="settings-nav">
                        <button
                            className={`nav-button ${activeTab === 'general' ? 'active' : ''}`}
                            onClick={() => setActiveTab('general')}
                        >
                            <Settings size={20} />
                            <span>Général</span>
                        </button>
                        <button
                            className={`nav-button ${activeTab === 'qualifications' ? 'active' : ''}`}
                            onClick={() => setActiveTab('qualifications')}
                        >
                            <CheckSquare size={20} />
                            <span>Qualifications</span>
                        </button>
                        <button
                            className={`nav-button ${activeTab === 'lamal' ? 'active' : ''}`}
                            onClick={() => setActiveTab('lamal')}
                        >
                            <Activity size={20} />
                            <span>Gestion LAMAL</span>
                        </button>
                        <button
                            className={`nav-button ${activeTab === 'lca' ? 'active' : ''}`}
                            onClick={() => setActiveTab('lca')}
                        >
                            <List size={20} />
                            <span>Gestion LCA</span>
                        </button>
                    </nav>
                </div>

                {/* Content Area */}
                <div className="settings-content">
                    {activeTab === 'general' && <GeneralSettings />}
                    {activeTab === 'qualifications' && <QualificationsPageWrapper />}
                    {activeTab === 'lamal' && <ListSettings type="lamal" title="Gestion LAMAL" />}
                    {activeTab === 'lca' && <ListSettings type="lca" title="Gestion LCA" />}
                </div>
            </div>
        </div>
    )
}

// Wrapper to adjust style or pass props if needed
function QualificationsPageWrapper() {
    return (
        <div style={{ margin: '-24px' }}> {/* Counteract padding from settings-content if needed or just let it be */}
            {/* QualificationsPage has its own layout, so we might might want to render it directly or wrap it. 
               Since it has a page title, we might want to hide it or keep it. 
               Let's render it as is. */}
            <QualificationsPage key="qual" />
        </div>
    )
}
